/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState, forwardRef, useImperativeHandle, useEffect } from 'react';
import CardWrapper from 'Components/Common/Card/Card';
import { Button, Row } from 'react-bootstrap';
import SignUpRewardPopup from './SignUpRewardPopup';
import SignUpBlackListPopup from './SignUpBlackListPopup';

import ActionButtons from 'Components/Page/Campaign/RegisterCampaign/Common/ActionButtons';
import { useAppSelector } from 'App/Store';
import useCampaign from 'Hooks/useCampaign';
import SpinnerComponent from 'Components/Common/SpinnerComponent';
import TableAward from './TableAward';
import TableBlackList from './TableBlackList';
import PaginationComponent from 'Components/Common/Pagination/index';
import { PER_PAGE_10 } from 'Constant';
import { BlackList } from 'Types/Page/Campaign/RegisterCampaign';

interface prizeType {
  visible: boolean;
  prize?: any;
}
interface blackListType {
  visible: boolean;
  blacklist?: any;
  blacklists?: any;
}
const StepSignUpRewards = forwardRef((props: any, ref: any): JSX.Element => {
  const { step, overview, prizes, blacklists } = useAppSelector((state) => state.campaign);
  const { handleChangeStep, isLoading } = useCampaign();
  const [currentPrize, setCurrentPrize] = useState<prizeType>({
    visible: false,
    prize: {},
  });
  const [currentBlackList, setCurrentBlackList] = useState<blackListType>({
    visible: false,
    blacklist: [],
  });
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [currentDataBlackList, setCurrentDataBlackList] = useState<BlackList[]>([]);

  const handleShowBonusModal = ({ visible, prize }: prizeType) => {
    visible
      ? setCurrentPrize({ visible, prize })
      : setCurrentPrize({
          visible: false,
          prize: {},
        });
  };
  const handleShowBlackListModal = ({ visible, blacklist }: blackListType) => {
    visible
      ? setCurrentBlackList({ visible, blacklist, blacklists })
      : setCurrentBlackList({
          visible: false,
          blacklist: {},
        });
  };

  const handleNext = () => {
    handleChangeStep(step + 1);
  };

  useImperativeHandle(ref, () => ({
    handleNextStepFromParent() {
      handleNext();
    },
  }));
  const onChangePage = (page: number) => {
    setCurrentPage(page);
    paginate(page, blacklists);
  };
  const paginate = (pageNumber: number, blackList: BlackList[]) => {
    console.log(blackList);
    if (blackList.length === 0 || pageNumber < 1) {
      setCurrentDataBlackList([]);
      return;
    }
    const startIndex = (pageNumber - 1) * PER_PAGE_10;
    const endIndex = pageNumber * PER_PAGE_10;
    const currentData: BlackList[] = blackList.slice(startIndex, endIndex);
    setCurrentDataBlackList(currentData);
  };
  const getDataUpdate = (data: BlackList[]) => {
    console.log(data);
    paginate(currentPage, data);
  };
  useEffect(() => {
    paginate(currentPage, blacklists);
  }, []);

  return (
    <>
      <SpinnerComponent isLoading={isLoading} />
      <div className="register-campaign-step-3">
        <CardWrapper title={`Chiến dịch: ${overview?.name}`}>
          <Row className="mb-3">
            <div className="d-flex">
              <div className="me-3 align-self-end">
                <Button
                  className="btn-action"
                  onClick={() =>
                    handleShowBonusModal({
                      visible: true,
                    })
                  }
                >
                  Đăng ký giải thưởng
                </Button>
              </div>
              {/* <div className="me-3 align-self-end">
                <Button
                  className="btn-action"
                  onClick={() =>
                    handleShowBlackListModal({
                      visible: true,
                    })
                  }
                >
                  Đăng ký danh sách chặn
                </Button>
              </div> */}
            </div>
          </Row>
          <Row>
            <TableAward
              handleShow={(prize: any) => {
                handleShowBonusModal({
                  visible: true,
                  prize,
                });
              }}
              prizes={prizes}
            />
          </Row>

          <Row>
            <TableBlackList
              handleShow={(blacklist: any) => {
                handleShowBlackListModal({
                  visible: true,
                  blacklist,
                });
              }}
              blacklists={currentDataBlackList}
            />
            <PaginationComponent
              onClick={onChangePage}
              activePage={currentPage ?? 1}
              total={blacklists.length ?? 0}
              perPage={PER_PAGE_10}
            />
          </Row>
        </CardWrapper>
        <ActionButtons handleBack={() => handleChangeStep(step - 1)} handleNext={handleNext} />
        {currentPrize.visible && (
          <SignUpRewardPopup
            currentPrize={currentPrize}
            handleShow={() => {
              handleShowBonusModal({ visible: false });
            }}
          />
        )}

        {currentBlackList.visible && (
          <SignUpBlackListPopup
            currentBlackList={currentBlackList}
            handleShow={(data) => {
              data ? getDataUpdate(data) : null;
              handleShowBlackListModal({ visible: false });
            }}
          />
        )}
      </div>
    </>
  );
});

export default StepSignUpRewards;
